import { useMutation, useQuery } from "@tanstack/react-query";
import { getDashboardSteps, updateDashboardSteps } from "api/dashboard";
import { queryClient } from "client";

export const useDashboardSteps = () => {
  return useQuery(["dashboardSteps"], getDashboardSteps, {
    select: (data) => data?.data,
  });
};


export const useUpdateDashboardSteps = () => {
  return useMutation(updateDashboardSteps, {
    onSuccess: () => {
      queryClient.invalidateQueries(["dashboardSteps"]);
    },
    onError: (error) => {
      console.error("Error updating dashboard steps:", error);
    },
  });
};